var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.438 17.4316C17.6797 17.1742 19.8823 16.6611 22 15.903C20.2066 13.9763 19.2156 11.4719 19.2195 8.87623V8.0011C19.2195 6.14429 18.459 4.36353 17.1051 3.05057C15.7513 1.73761 13.9152 1 12.0006 1C10.086 1 8.24987 1.73761 6.89606 3.05057C5.54225 4.36353 4.78169 6.14429 4.78169 8.0011V8.87623C4.78532 11.472 3.79388 13.9765 2 15.903C4.08506 16.6498 6.28322 17.169 8.5632 17.4316M15.438 17.4316C13.1544 17.6943 10.8468 17.6943 8.5632 17.4316M15.438 17.4316C15.6114 17.9565 15.6545 18.5137 15.5638 19.0578C15.4732 19.602 15.2513 20.1177 14.9163 20.5629C14.5813 21.0082 14.1426 21.3704 13.6359 21.6201C13.1293 21.8698 12.5689 22 12.0006 22C11.4323 22 10.872 21.8698 10.3653 21.6201C9.85862 21.3704 9.41993 21.0082 9.08491 20.5629C8.74989 20.1177 8.52802 19.602 8.43736 19.0578C8.3467 18.5137 8.38982 17.9565 8.5632 17.4316",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityInactive);
export default __webpack_public_path__ + "static/media/activity_inactive.7ea3a12aa95de937af967e92aa660911.svg";
export { ForwardRef as ReactComponent };